import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import {
    SendBillsProps,
    sendEmails,
    sendInvoiceReminder,
} from '@mews-commander/legacy-entities/src/actions/typed/bills';
import { maxInputTextLength, presence, TextareaField, validation } from '@mews-commander/legacy-form';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { closeDialog } from '../../../../modules/dialog/reducer';
import { SendEmailType } from './Action/SendFinancialDocumentToEmailAction';
import { FormValues as PrintReasonFormValues, submitPrintReason } from './PrintReasonDialogForm';

export const formName = 'repeatedPrint';

export interface WithOptionalFirstUsedTemplateType {
    firstUsedTemplateType?: string | null;
}

export type PrintFormValues = PrintReasonFormValues & { firstUsedTemplateType: string };

export type EmailPrintFormValues = Omit<SendBillsProps, 'printReason'> & { firstUsedTemplateType: string } & {
    reason: string;
};

interface DispatchProps {
    onSubmit: (values: PrintFormValues | EmailPrintFormValues) => void;
    onSubmitSuccess: () => void;
}

const constraints = {
    reason: {
        presence,
        length: maxInputTextLength,
    },
};

const reasonProps = {
    name: 'reason',
    label: <LocalizedText textKey={TextKey.DifferentTemplatePrintReason} />,
    required: true,
};

const RepeatedPrintDialogForm = () => <TextareaField {...reasonProps} />;

export default pipe(
    RepeatedPrintDialogForm,
    reduxForm({
        validate: validation(constraints),
        form: formName,
    }),
    connect<{}, DispatchProps, { type: SendEmailType }, ApplicationState>(
        null,
        (dispatch: CommanderThunkDispatch, { type }) => ({
            onSubmit: async (values) => {
                if ('emails' in values) {
                    switch (type) {
                        case 'SendBill':
                            return dispatch(sendEmails({ ...values, printReason: values.reason }));
                        case 'SendReminder':
                            return dispatch(
                                sendInvoiceReminder({
                                    ...values,
                                    invoiceId: values.financialDocumentId,
                                    printReason: values.reason,
                                })
                            );
                    }
                }
                return dispatch(submitPrintReason(values));
            },
            onSubmitSuccess: () => dispatch(closeDialog(formName)),
        })
    )
);
